import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import {
  Button,
  Text,
  makeStyles,
  tokens,
} from "@fluentui/react-components";
import AdminService from "../AdminService";
import {
  DismissCircle32Regular
} from "@fluentui/react-icons";
import { useAdminAuth } from "../AdminAuthContext";

const useStyles = makeStyles({
  container: {
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "18px",
    textAlign: "center",
    padding: "0 24px",
  },
  icon: {
    color: tokens.colorPaletteRedForeground2,
  },
  title: {
    fontSize: "24px",
    fontWeight: "600",
  },
  description: {
    fontSize: "16px",
    color: tokens.colorNeutralForeground2,
    maxWidth: "480px",
  }
});

export default function OauthRedirect() {
  const navigate = useNavigate();
  const styles = useStyles();

  const [errorState, setErrorState] = useState(null);
  const [loading, setLoading] = useState(true);
  const { userInfo } = useAdminAuth();

  const handleSaveTenant = async (tenant) => {
    try {
      console.log("handleSaveTenant", tenant);

      await AdminService.postSFConnection({
        "sfOrgId": tenant?.orgId,
        "sfInstanceUrl": tenant?.instanceUrl,
        "sfOrgOwner": tenant?.username,
        "sfOrgOwnerUserId": tenant?.adminUserId,
        "tenantId": userInfo?.tenantId
      }
      );
      console.log('Tenant configuration saved successfully ');
      navigate("/?page=authorization&tab=salesforce");

    } catch (err) {
      console.error("Save failed", err);
      setErrorState({
        message: "Failed to save Salesforce connection",
      });
    }
  };

  useEffect(() => {
    // eslint-disable-next-line no-undef
    const params = new URLSearchParams(window.location.search);

    const code = params.get("code");
    const error = params.get("error");
    const errorDescription = params.get("error_description");

    // Handle OAuth Error (NO redirect)
    if (error) {
      setErrorState({
        error,
        message: decodeURIComponent(errorDescription || "Unknown error"),
      });
      setLoading(false);
      return;
    }

    if (!code) {
      setErrorState({
        message: "Authorization code not found",
      });
      setLoading(false);
      return;
    }

    const codeVerifier = localStorage.getItem("sf_pkce_verifier");
    const sfEnv = localStorage.getItem("sf_env") || "prod";
    if (!codeVerifier) {
      setErrorState({
        message: "Missing PKCE verifier",
      });
      setLoading(false);
      return;
    }

    const sendCode = async () => {
      try {
        const res = await AdminService.exchangeSalesforceCode({
          code,
          codeVerifier,
          sfEnv
        });

        localStorage.removeItem("sf_pkce_verifier");
        localStorage.removeItem("sf_env");
        handleSaveTenant(res); // save tenant config before navigating
      } catch (err) {
        console.error("OAuth failed:", err);

        setErrorState({
          message: "Token exchange failed",
        });
        setLoading(false);
      }
    };

    sendCode();
  }, []);

  //  Loading UI
  if (loading) {
    return <div>Connecting to Salesforce...</div>;
  }

  //  Error UI
  if (errorState) {
    return (
      <div className={styles.container}>
        <DismissCircle32Regular className={styles.icon} />

        <Text className={styles.title}>
          Salesforce Connection Failed
        </Text>

        <Text className={styles.description}>
          {errorState?.error === "OAUTH_EC_APP_NOT_FOUND"
            ? "Unaric Voice for Teams Sync package is not installed in this org"
            : errorState?.message ||
            "Something went wrong while connecting to Salesforce"}
        </Text>

        <Button
          appearance="primary"
          onClick={() =>
            navigate("/?page=authorization&tab=salesforce")
          }
        >
          Back to Portal
        </Button>
      </div>
    );
  }

  return null;
}